import { Flex } from 'antd';
import cx from 'clsx';
import Icon from '../icon/Icon';
import styles from './SelectItem.module.scss';

const SelectItem = ({ title = '', onClick = () => {}, style = {} }) => {
  return (
    <Flex
      style={style}
      className={cx('', styles.selectItemContainer)}
      align="center"
      justify="space-between"
      onClick={onClick}
    >
      <div>{title}</div>
      <Icon icon={'ArrowRightIcon'} color={'var(--user-main-text-2)'} />
    </Flex>
  );
};

export default SelectItem;
